<template>
  <span class="pe-icon" :class="iconType">
    <template v-if="icon">
      {{ icon }}
    </template>
    <slot v-else />
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { clamp } from '@/common/util'

const props = defineProps<{
  type?: string
  fill?: boolean
  weight?: number | string
  grade?: number | string
  opticalSize?: number | string
  size?: number | string
  icon?: string
}>()

/**
 * Define o estilo do Material Symbol
 */
const iconType = computed(() => ({
  outlined: 'material-symbols-outlined',
  rounded: 'material-symbols-rounded',
  sharp: 'material-symbols-sharp'
}[props.type || 'outlined']))


/**
 * Normaliza o "peso" (espessura do tracejado) do icone
 */
const iconWeight = computed(() => ((parseInt(`${props.weight || 400}`) / 100) | 0) * 100)

/**
 * Normaliza o preenchimento do icone
 */
const iconFill = computed(() => (props.fill ? 1 : 0))

/**
 * Normaliza o a ênfase do icone (valores permitidos: -25, 0 e 200, menos ênfase a mais ênfase)
 */
const iconGrade = computed(() => ({ '-25': -25, '0': 0, '200': 200 }[`${props.grade}`] || 0))

/**
 * Normaliza o a ênfase do icone (valores permitidos: 20 a 48 Dp)
 */
const iconOpsz = computed(() => clamp(parseInt(`${props.opticalSize || 24}`), 20, 48))

/**
 * Normaliza o tamanho da fonte (inherit caso omisso)
 */
const iconSize = computed(() => {
  if (!props.size) return 'inherit'
  else return typeof props.size === 'number' ? `${props.size}px` : props.size
})
</script>

<style lang="scss" scoped>
.material-symbols-outlined,
.material-symbols-rounded,
.material-symbols-sharp {
  font-size: v-bind(iconSize);
  vertical-align: middle;
  font-variation-settings: 'FILL' v-bind(iconFill), 'wght' v-bind(iconWeight), 'GRAD' v-bind(iconGrade),
    'opsz' v-bind(iconOpsz);
}
</style>
